import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * The field chassis (design 14a). Every other text-entry control in the
 * library — Textarea, Select's trigger, the pickers, the value-picker trigger —
 * reuses these classes so a form reads as one control repeated, not five
 * lookalikes.
 *
 * 16px text below `md` is deliberate: iOS zooms the viewport when it focuses an
 * input smaller than that, and the zoom never animates back.
 */
export const inputChassis =
  "flex h-9 w-full rounded-lg border border-input bg-card px-3 py-1 text-base shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring aria-[invalid=true]:border-destructive disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          inputChassis,
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
